import { UrlObject } from 'url';

import * as React from 'react';

interface Properties {
  lineDescription: string;
  lineUrl: Partial<UrlObject>;
  // FIXME: Whitelist Function from ban-types lint rule - some places we don't
  // care about the implementation of callbacks, hence a very generic typed
  // Function is useful.
  refreshLine: (name: string, id: string) => void;
}

export const LineDescriptionContext = React.createContext<Properties>({
  lineDescription: '',
  lineUrl: {},
  refreshLine: () => undefined,
});
